import React from "react";

import { IvideonFaceAnalytics } from "~/entity/Ivideon";
import {
  dataContentInfoCardPeople,
  formatDwellTime,
} from "~/pages/IvideonDealerSummary2/options";

import InfoItemBlock from "./InfoItemBlock";

interface InfoBlockPeopleIProps {
  data: IvideonFaceAnalytics;
  variant: string | null;
}

const InfoBlockPeople = ({ data, variant }: InfoBlockPeopleIProps) => {
  const getResult = (value: string): number | string => {
    if (value === "uniqueFaces") return data?.uniqueFaces ?? 0;
    if (value === "newFaces") return data?.newFaces ?? 0;
    if (value === "returningFaces") return data?.returningFaces ?? 0;
    if (value === "gender") {
      const male = data?.totalGenderDetails?.male ?? 0;
      const female = data?.totalGenderDetails?.female ?? 0;
      return `${male} / ${female}`;
    }
    if (value === "visitTime")
      return formatDwellTime(data?.overallAverageDwellTime ?? 0);
    return 0;
  };

  return (
    <>
      {dataContentInfoCardPeople.map((info) => {
        const result = getResult(info.value);
        return (
          <InfoItemBlock
            key={info.value}
            result={typeof result === "number" ? result : 0}
            label={info.label}
            variant={variant}
            switcher={true}
            data={info.value}
            customValue={typeof result === "string" ? result : undefined}
          />
        );
      })}
    </>
  );
};

export default InfoBlockPeople;
